import { gql } from "@apollo/client";

export const getZonesQuery = gql`
query GetZones($search: String) {
  getZones(search: $search) {
    message
    response {
      _id
      name
      description
      code
      createdAt
      createdBy
    }
  }
}
`;


export const getZoneByIdQuery = gql`
    query($getZoneByIdId: String!){
    getZoneById(id: $getZoneByIdId) {
        message
        response {
        _id
        code
        name
        description
        }
    }
    }
`;